<template>
  <div class="container-fluid astrology-birth-chart-container pt-2">
    <BirthChartInputData
      v-if="!is_birth_chart"
      :is_birth_chart.sync="is_birth_chart"
      :name.sync="name"
      :gender.sync="gender"
      :date.sync="date"
      :time.sync="time"
      :location.sync="location"
    />
    <P5Index
      v-else
      :is_birth_chart="is_birth_chart"
      :name="name"
      :gender="gender"
      :date="formatDate(date)"
      :time="time"
      :location="location"
    />
      <!-- <P5Index
      :is_birth_chart="true"
      :name="name"
      :gender="gender"
      :date="formatDate(date)"
      :time="time"
      :location="location"/> -->
  </div>
</template>


<script>
import BirthChartInputData from "./BirthChartInputData.vue";
import P5Index from "@/components/P5/Index.vue";
import moment from "moment";

export default {
  name: "AstrologyCustomerCreateBirthChartIndex",
  components: { BirthChartInputData, P5Index },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",

      name: null,
      gender: null,
      date: null,
      date_str:null,
      time: null,
      location: null,
      latitude: null,
      longitude: null,

      is_birth_chart: false,
    };
  },
  mounted() {
    // console.log()
    // console.log(window.localStorage.getItem("user"))
    let user = window.localStorage.getItem("user");
    if (user != null) {
      let user_json = JSON.parse(user);
      //  console.log(user)
      this.user_name = user_json.name;
    }
  },
  methods:{
    formatDate(date){
        return  moment(date).format("ddd, DD MMM YYYY")
    }
  }
};
</script>

<style scoped::v-deep >
</style>


// WEBPACK FOOTER //
// src/components/astrology_ventures/customer/birth_chart/Index.vue